/* unplugin-vue-components disabled */import { render } from "./NextBtnGroup.vue?vue&type=template&id=10d7cc9c"
import script from "./NextBtnGroup.vue?vue&type=script&lang=js"
export * from "./NextBtnGroup.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__